<template>
    <v-row align="center" class="academy-router">
        <v-col
            v-for="(icon, index) in icons"
            :key="index" cols="6" lg="3"
            class="d-flex flex-column align-center"
            style="cursor: pointer"
            @click="$router.push({ path: icon.link })"
        >
            <div
                style="width: 80%; padding-top: 80%; position: relative; border-radius: 30px; "
                :style="`background: ${icon.background};`"
                class="elevation-2 d-flex justify-center align-center"
            >
                <v-icon style="position: absolute; top: 0; left: 0; bottom: 0; right: 0;" color="white" :size="$vuetify.breakpoint.mobile ? '64px' : '96px'">{{ icon.icon }}</v-icon>
            </div>
            <!-- <img style="width: 90%; border-radius: 30px;" class="elevation-2" :src="icon.path" /> -->
            <br />
            {{ icon.text }}
        </v-col>
    </v-row>
</template>

<script>
export default {
    data () {
        return {
            icons: [
                {
                    text: 'Moduler',
                    link: '/user/training',
                    background: '#00FFFF',
                    icon: 'fa-stream'
                },
                {
                    text: 'Kalender',
                    link: '/academy/calendar',
                    background: '#FFA300',
                    icon: 'fa-calendar-alt'
                },
                {
                    text: 'Monitorering',
                    link: '/academy/monitoring',
                    background: '#029E2A',
                    icon: 'fa-headphones-alt'
                },
                {
                    text: 'Highscores',
                    link: '/academy/highscore',
                    background: '#E81600',
                    icon: 'fa-award'
                }
            ]
        }
    }
}
</script>

<style lang="scss">
.academy-router {
    height: calc(100vh - 150px);
}
</style>